<template>
	<div>
		<div v-if="!loaded">
			<Loader></Loader>
		</div>
		<div v-if="loaded">
			<div v-if="signed">
				<a :href="contractLink" target="_blank"><button>{{ $t('finalized.view-contract') }}</button></a>
				<a v-if="energyRankLink" :href="energyRankLink" target="_blank"><button>{{ $t('finalized.view-energy-rank') }}</button></a>
				<a v-if="houseRulesLink" :href="houseRulesLink" target="_blank"><button>{{ $t('finalized.view-house-rules') }}</button></a>
			</div>
			<div v-else>
				Contract has not yet been signed by all parties yet
			</div>
		</div>
	</div>
</template>

<script>
    import Loader from '../../components/Loader.vue';

	import {mapGetters} from 'vuex';

	export default {
		data: () => ({
			loaded: false,
			signed: false,
			contractLink: '',
			energyRankLink: '',
			houseRulesLink: ''
		}),
		components: {
			Loader
		},
		computed: {
			...mapGetters([
				'getToken'
			])
		},
		methods: {
			fetchContract() {
				var self = this;
				axios({
					method: 'POST',
					url: window.config.apiUrl + 'api/contract/finalized/' + this.$route.params.id,

				}).then(response => {
					self.loaded = true;
					self.signed = response.data.signed;
					self.contractLink = window.config.apiUrl + 'contract/' + this.$route.params.id + '?token=' + this.getToken;
					self.houseRulesLink = window.config.apiUrl + response.data.houseRulesLink + '?token=' + this.getToken;
					self.energyRankLink = window.config.apiUrl + response.data.energyRankLink + '?token=' + this.getToken;
				});
			}
		},
		created() {
			this.fetchContract();
		}
	}
</script>
